import { PEV } from "../common/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as service from "./service";

const initialState = {
  featureToggleList: PEV(
    {
      data: [],
    },
    "Not Loaded"
  ),
};

const getFeatureToggles = createAsyncThunk("featureToggleList/get", async () => {
  return await service.getFeatureToggles();
});

const FeatureToggleSlice = createSlice({
  name: "featureToggleList",
  initialState,
  reducers: {},
  extraReducers: {
    [getFeatureToggles.pending.type]: (state) => {
      state.featureToggleList = PEV({ ...state.featureToggleList }, "Fetching applications");
    },
    [getFeatureToggles.fulfilled.type]: (state, action) => {
      state.featureToggleList = PEV({ data: action.payload });
    },
    [getFeatureToggles.rejected.type]: (state) => {
      state.featureToggleList = PEV(
        { ...state.featureToggleList },
        null,
        "Error while fetching applications"
      );
    },
  },
});

export const FeatureToggleActions = { getFeatureToggles };
export const FeatureToggleReducer = FeatureToggleSlice.reducer;
